import { apiConfig as config, request } from '@/shared/io';
import { handleDictObjRequest } from '../utils/dict';
// 获取重置密码所需验证吗
export const getSmsCode = async (data) => {
    return request(`${config.apiUims}/v1/unlogin/sms/code`, {
        method: 'POST',
        data,
    });
};
//校验验证码
export const checkSmsCode = async (data) => {
    return request(`${config.apiUims}/v1/unlogin/sms/code/check`, {
        method: 'POST',
        data,
    });
};
// 用户重置密码
export const resetPassword = (data) => {
    return request(`${config.apiUims}/v1/unlogin/user/reset/psw`, {
        method: 'POST',
        data,
    });
};
// 注册用户
export const registerUser = (data) => {
    return request(`${config.apiUims}/v1/unlogin/register/user`, {
        method: 'POST',
        data,
    });
};
/**
 * 查询单个字典
 * @param data
 * @param headers
 * @returns
 */
export async function queryDictCodeByCode(data, headers = {}) {
    return handleDictObjRequest(`${config.apiUims}/v1/dict/code/${data}`, {
        method: 'post',
        headers,
    });
}
/**
 * 查询多个字典
 * @param data
 * @param headers
 * @returns
 */
export async function queryDictCodeByCodes(data, headers = {}) {
    return handleDictObjRequest(`${config.apiUims}/v1/dict/codes/${data}`, {
        method: 'get',
        headers,
    });
}
// api/uims/v1/app/checkSystem/329301748600823903
export async function getAiPermision(id, headers) {
    return request(`${config.apiUims}/v1/app/checkSystem/${id} `, {
        method: 'get',
        headers: headers || {
            'depend-uri': '/api/uims/v1/system/list/{useScope}',
            'depend-method': 'GET',
        },
    });
}
